<template>
    <header>
        <!--navs-->
        <response-nav-widget :header-nav-data="mainNavData" />

        <section class="pad-t-7 mrg-b-10 pad-h-3 mrg-b-7-s">
            <img :src="require(`@/assets/img/daas_case/${packageId}_title.png`)" />
        </section>
    </header>
</template>

<script>
    import ResponseNavWidget from "@/components/zk2861/response-nav-widget"

    export default {
        name: "sec-header-widget",
        components: {
            ResponseNavWidget
        },
        props: ["packageId", "mainNavData"]
    }
</script>


// WEBPACK FOOTER //
// src/components/sec-header-widget.vue